<template>
  <div class="ui-chess-section" :class="classList">
    <p class="ui-chess-section-name">{{ section.name }}</p>
    <div class="ui-chess-section-rooms">
      <div
          class="ui-chess-section-rooms__row"
          v-for="floor in section.floors"
          :key="floor.id"
      >
        <p class="ui-chess-section-rooms__floor">{{ floor.number }}</p>
        <div class="ui-chess-section-rooms__items">
          <ui-chess-item
              class="ui-chess-section-rooms__cell"
              v-for="room in floor.rooms"
              :key="room.id"
              :room="room"
              :size="size"
              :has-color-status="hasColorStatus"
              :has-room-count="hasRoomCount"
              :has-room-comment="hasRoomComment"
              :has-grades="hasGrades"
              :active="isSelectActive(room)"
              :disabled="isDisabled(room)"
              @close-action-modal="closeActionModal"
              @open-action-modal="openActionModal"
              @click="clickRoom(room)"
          />
        </div>
      </div>
      <template v-if="roomsWithoutFloor.length">
        <p class="ui-chess-section-name">Без этажа</p>
        <div class="ui-chess-section-rooms__row _without-floor">
          <div class="ui-chess-section-rooms__items">
            <ui-chess-item
              class="ui-chess-section-rooms__cell"
              v-for="room in roomsWithoutFloor"
              :key="room.id"
              :room="room"
              :size="size"
              :has-room-comment="hasRoomComment"
              :has-color-status="hasColorStatus"
              :has-room-count="hasRoomCount"
              :has-grades="hasGrades"
              :active="isSelectActive(room)"
              :disabled="isDisabled(room)"
              @close-action-modal="closeActionModal"
              @open-action-modal="openActionModal"
              @click="clickRoom(room)"
            />
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import UiChessItem from './UiChessItem.vue'

export default {
  name: 'UiChessSection',
  components: { UiChessItem },
  props: {
    section: {
      type: Object,
      default: () => ({})
    },

    size: {
      type: String,
      default: 'm'
    },

    hasColorStatus: {
      type: Boolean,
      default: false
    },

    hasRoomCount: {
      type: Boolean,
      default: false
    },

    selectedRooms: {
      type: Array,
      default: () => []
    },

    filterRooms: {
      type: Array
    },

    hasRoomComment: {
      type: Boolean,
      default: false
    },

    hasGrades: Boolean
  },

  computed: {
    roomsWithoutFloor () {
      return this.section.rooms ?? []
    },
    classList () {
      return [`_size_${this.size}`]
    }
  },

  methods: {
    isSelectActive (room) {
      const selectedCount = this.selectedRooms.length
      const isActive = Boolean(selectedCount && this.selectedRooms.indexOf(room.id) !== -1)
      if (isActive && selectedCount === 1) {
        this.$emit('set-active-room', room)
      }
      return isActive
    },

    isDisabled ({ id }) {
      return this.filterRooms ? !this.filterRooms?.includes(id) : false
    },

    openActionModal (event) {
      this.$emit('open-action-modal', event)
    },

    closeActionModal () {
      this.$emit('close-action-modal')
    },

    clickRoom ({ id }) {
      this.$emit('click-room', id)
    }
  }
}
</script>

<style lang="scss" scoped>
$floorNameWidth: 24px;
$floorNameMargin: 12px;
$floorNameSize: $floorNameWidth + $floorNameMargin;

$cellWidthS: 38px;
$cellWidthM: 85px;
$cellWidthL: 160px;

$gap: 10px;

$maxCellsInRow: 16;

@function get-section-max-width($cellWidth, $gap: $gap, $maxCellsInRow: $maxCellsInRow) {
  @return ($cellWidth + $gap) * $maxCellsInRow
}

.ui-chess-section {
  @include transition-list('max-width', .3s);
  $parent: &;
  flex-shrink: 0;

  &._size {
    &_s {
      max-width: get-section-max-width($cellWidthS)
    }
    &_m {
      max-width: get-section-max-width($cellWidthM)
    }
    &_l {
      max-width: get-section-max-width($cellWidthL)
    }
  }

  &-name {
    margin: 24px 0 24px $floorNameSize;
    text-align: center;
    color: #686E7C;
  }

  &-rooms {
    @include hidden-scrollbar;

    &__row {
      display: flex;

      &._without-floor {
        justify-content: center;
        margin-left: $floorNameSize;
      }
    }

    &__items {
      @include flex-center;
      flex-wrap: wrap;
      flex: 1;
    }

    &__floor {
      @include font-14;
      @include flex-center;

      color: #C4C6CB;
      width: $floorNameWidth;
      margin-right: $floorNameMargin;
      margin-bottom: 0;
    }

    &__cell {
      margin: 5px;
    }
  }
}
</style>
